import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { Controls } from './controls/Controls';
import Modal from './Modal';

export default function ConfirmExportModal({ isOpen, handleClose, onConfirm }) {
  const handleClick = (confirm) => {
    onConfirm(confirm);
    handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Export Settings"
    >
      <div style={{ padding: '20px' }}>
        <Typography variant="body1" sx={{ mb: 3, fontSize: '1.1rem' }}>
          What would you like to export?
        </Typography>
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px',
          marginTop: '20px',
        }}
        >
          <Controls.Button
            text="Settings Only (for copying to an existing site)"
            variant="outlined"
            onClick={() => handleClick(false)}
          />
          <Controls.Button
            text="Full Site Schematic (for creating a new site)"
            variant="contained"
            onClick={() => handleClick(true)}
          />
        </div>
      </div>
    </Modal>
  );
}

ConfirmExportModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
